import { render } from "./OsmAttribution.vue?vue&type=template&id=332822fa"
import script from "./OsmAttribution.vue?vue&type=script&lang=js"
export * from "./OsmAttribution.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__